import { defineCustomElement } from './defineCustomElementWithStyles'
import AeropostSearch from './AeropostSearch.ce.vue'
import pinia from './stores/index'
import i18n from './i18n/index'

const AeropostSearchElement = defineCustomElement(AeropostSearch, {
  plugins: [pinia, i18n],
})

customElements.define('aeropost-search', AeropostSearchElement)

function createInstance() {
  const ce = document.createElement('aeropost-search')
  const container = document.querySelector('#content-wrapper')

  container.textContent = ''
  container.appendChild(ce)

  return ce
}

window.productSearch = (query, params = {}) => {
  const ce = document.querySelector('aeropost-search') || createInstance()

  ce.dispatchEvent(new CustomEvent('ap:search', { detail: { query, params } }))
}

if (!window.onpopstate) {
  window.onpopstate = async () => {
    document.querySelector('aeropost-search') || createInstance()
  }
}
